module.exports = __webpack_public_path__ + "media/images/category_icons/places-cec5f1d2e1ccd81e8e8c6b94935eeb2e.svg";